import { render, staticRenderFns } from "./RequestVerificationEmail.vue?vue&type=template&id=5d2f7d12&scoped=true"
import script from "./RequestVerificationEmail.vue?vue&type=script&lang=js"
export * from "./RequestVerificationEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2f7d12",
  null
  
)

export default component.exports